import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate, useParams } from 'react-router-dom';
import BASE_URL from '../config';
import Sidebarpo from './Sidebarpo';
import Select from "react-select";






  


const ClonePO = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // get ID from route
  const [clients, setClients] = useState([]);
    const [suppiler, setSupplier] = useState([]);
  const user = JSON.parse(localStorage.getItem("userdata"));
  
 const [file1, setFile1] = useState(null);
   const [poLength, setPoLength] = useState("");


const [formData, setFormData] = useState({
  client_name: "",
  client_po_number: "",
  client_po_date: "",
  items_description: "",
  client_po_value: "",
  client_delivery_date: "",
  supplier_po_number: "",
  supplier_po_value: "",
  currency: "",
  c_currency: "",
  supplier_name: "",
  latest_update: "",
  pearlcon_contact: "",
  supplier_payment: "",
  supplier_delivery_date: "",
  client_payment: "",
  current_status: "",
  rfq_number: "",
  status_feedback: "",
  po_attachment: "", // <-- This is the file path only
});


  useEffect(() => {
    fetchClients();
   fetchSupplier ();

    if (id) {
      fetchPOData(id);
    }
  }, [id]);

  const fetchClients = () => {
    axios
      .get(`${BASE_URL}/api/client-get`)
      .then((res) => setClients(res.data))
      .catch((err) => console.error("Error fetching clients:", err));
  };
const fetchSupplier = () => {
    axios
      .get(`${BASE_URL}/api/supplier-get`)
      .then((res) => {
        setSupplier(res.data);
      })
      .catch((err) => {
        console.error("Error fetching clients:", err);
      });
  };
  const fetchPOData = async (id) => {
    try {
      const response = await axios.get(`${BASE_URL}/api/get-po-data/${id}`);
      const data = response.data;
 if (data.po_attachment) {
      setFile1(data.po_attachment); // means user hasn't changed file yet
    }
      setFormData((prev) => ({
        ...prev,
        client_name: data.client_name || "",
        client_po_number: data.client_po_number || "",
        client_po_date: data.client_po_date || "",
        items_description: data.items_description || "",
        client_po_value: data.client_po_value || "",
        client_delivery_date: data.client_delivery_date || "",
        supplier_po_number:   data.supplier_po_number || "",
        supplier_po_value: data.supplier_po_value || "",
        currency: data.currency || "",
        c_currency: data.c_currency || "",
        supplier_name: data.supplier_name || "",
        latest_update: data.latest_update || "",
        pearlcon_contact: data.pearlcon_contact || "",
        supplier_payment: data.supplier_payment || "",
        supplier_delivery_date: data.supplier_delivery_date || "",
        client_payment: data.client_payment || "",
        current_status: data.current_status || "",
        rfq_number: data.rfq_number || "",
        status_feedback: data.status_feedback || "",
        po_attachment: data.po_attachment || "",
      }));
    } catch (error) {
      console.error("Error fetching PO data:", error);
    }
  };
  useEffect(() => {
      axios
        .get(`${BASE_URL}/api/get-po-data`)
        .then((response) => {
          
          const data = response.data;

      if (data.length > 0) {
        const latestId = Math.max(...data.map(item => item.id));
        setPoLength(latestId);

        console.log("Latest PO ID:clone", latestId);
      }
        })
        .catch((error) => {
          console.error("Error fetching PO data:", error);
        });
    }, []);

    
const handleChangeForm = (e) => {
  const { name, value } = e.target;

  if (name === "supplier_name" && value === "add_new") {
    navigate("/supplierpo");
    return;
  }

  if (name === "client_name" && value === "add_new") {
    navigate("/clientlist");
    return;
  }

  setFormData((prev) => {
    const updatedForm = {
      ...prev,
      [name]: value,
    };

    const clientName = updatedForm.client_name || "";
    const rfq = updatedForm.rfq_number || "";

    // Auto-generate PO number
    if (clientName.length >= 3 && rfq.length >= 6) {
      const clientCode = clientName.substring(0, 3).toUpperCase();
      const rfqSuffix = rfq.slice(-6);
      const poNumber = `${clientCode}-${poLength + 1}-${rfqSuffix}`;
      updatedForm.supplier_po_number = poNumber;
    }

    console.log("updatedForm", poLength, updatedForm);
    return updatedForm;
  });
};



  console.log("file111",file1);
  

const handleSubmit = async () => {
  // ✅ Compute PO number right before sending
  const clientName = formData.client_name || "";
  const rfq = formData.rfq_number || "";

  let poNumber = formData.supplier_po_number;
  if (clientName.length >= 3 && rfq.length >= 6 && poLength > 0) {
    const clientCode = clientName.substring(0, 3).toUpperCase();
    const rfqSuffix = rfq.slice(-6);
    poNumber = `${clientCode}-${poLength + 1}-${rfqSuffix}`;
  }

  const sendData = new FormData();

  Object.entries(formData).forEach(([key, value]) => {
    sendData.append(key, value);
  });

  // ✅ Override supplier_po_number with latest one
  sendData.set("supplier_po_number", poNumber);

  sendData.append("old_file", formData.po_attachment);
  if (file1 instanceof File) {
    sendData.append("po_attachment", file1);
  }

  try {
    const res = await axios.post(`${BASE_URL}/api/craetepodata`, sendData, {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    });

    Swal.fire(res.data.message || "PO created successfully!");
    handleSubmitCreatepo();
    navigate("/listpo");
  } catch (error) {
    console.error("Error submitting PO:", error.response?.data || error.message);
    Swal.fire("Failed to submit PO");
  }
};



const handleSubmitCreatepo = async () => {
    try {
      const response = await axios.post('https://bimanager.nexteck.uk/api/messages', 
        {
          user_id:user.id,
          type:"PO",
          message:"New PO Clone Created",
          status:"0"
        }
      );
      console.log(response.data);
    
    } catch (error) {
      console.error(error);
     
    }
  };

  return (
    <div className="row">
      <div className="custom-2-5  ">

      <Sidebarpo />
      </div>
      <div className="custom-9-5 dashboardsclooer p-4">
        <div className="card p-4 shadow">
          <h5 className="mb-3">CLONE PO</h5>
           <div className="row">
            <div className="form-group mb-3 col-lg-4">
  <label><strong>PO Attachment</strong></label><br />
  <input
    type="file"
    accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.png"
    onChange={(e) => setFile1(e.target.files[0])}
  />
  <input type="hidden" name ="old_file" value={formData.po_attachment}/>
    


  {/* Show View File if file path exists and no new file is selected */}
  {formData.po_attachment && (
    <a
      href={`${BASE_URL}/public/${formData.po_attachment}`}
      target="_blank"
      rel="noopener noreferrer"
      className="btn btn-sm btn-outline-primary mt-2"
    >
      View Current File
    </a>
  )}
</div>

           <div className="form-group mb-3 col-lg-4">
  <label>
    <strong>Client Name *</strong>
  </label>
  <Select
    name="client_name"
    options={[
      ...clients.map((client) => ({
        label: client.client_name,
        value: client.client_name,
      })),
      { label: "➕ Add New Client", value: "add_new" },
    ]}
    value={
      formData.client_name
        ? { label: formData.client_name, value: formData.client_name }
        : null
    }
    onChange={(selectedOption) => {
      if (!selectedOption) return;
      const value = selectedOption.value;

      // Redirect logic
      if (value === "add_new") {
        navigate("/clientlist");
        return;
      }

      // Reuse your existing handleChangeForm logic
      handleChangeForm({
        target: { name: "client_name", value },
      });
    }}
    placeholder="Select Client"
    isSearchable
    classNamePrefix="react-select"
  />
</div>


            {/* Required Fields */}
            {[
              {
                label: "Client PO Number *",
                name: "client_po_number",
                required: true,
              },
              {
                label: "Client PO Date *",
                name: "client_po_date",
                type: "date",
                required: true,
              },
            ].map(({ label, name, type = "text", required }) => (
              <div className="form-group mb-3 col-lg-4" key={name}>
                <label>
                  <strong>{label}</strong>
                </label>
                <input
                  type={type}
                  name={name}
                  required={required}
                  className="form-control"
                  value={formData[name]}
                  onChange={handleChangeForm}
                />
              </div>
            ))}

            {/* Optional Inputs */}
            {[
              { label: "Item Description", name: "items_description" },
              {
                label: "Client PO Value",
                name: "client_po_value",
                type: "number",
              },
              
            ].map(({ label, name, type = "text", readOnly = false }) => (
              <div className="form-group mb-3 col-lg-4" key={name}>
                <label>
                  <strong>{label}</strong>
                </label>
                <input
                  type={type}
                  name={name}
                  className="form-control"
                  value={formData[name]}
                  onChange={handleChangeForm}
                  readOnly={readOnly}
                />
              </div>
            ))}

 <div className="form-group mb-3 col-lg-4">
              <label>
                <strong>  Currency</strong>
              </label>
              <select
                name="c_currency"
                className="form-control"
                value={formData.c_currency}
                onChange={handleChangeForm}
              >
                <option value="">Select</option>
                <option value="GBP">GBP</option>
                <option value="USD">USD</option>
                <option value="EURO">EURO</option>
                <option value="SAR">SAR</option>
                <option value="QD">QD</option>
                <option value="AED">AED</option>
                <option value="Other">Other</option>
              </select>
            </div>

 {[
              
              {
                label: "Client Delivery Date",
                name: "client_delivery_date",
                type: "date",
              },
              {
                label: "Supplier PO Number",
                name: "supplier_po_number",
                readOnly: true,
              }, // ⬅️ updated line
              {
                label: "Supplier PO Value",
                name: "supplier_po_value",
                type: "number",
              },
              
            ].map(({ label, name, type = "text", readOnly = false }) => (
              <div className="form-group mb-3 col-lg-4" key={name}>
                <label>
                  <strong>{label}</strong>
                </label>
                <input
                  type={type}
                  name={name}
                  className="form-control"
                  value={formData[name]}
                  onChange={handleChangeForm}
                  readOnly={readOnly}
                />
              </div>
            ))}
             <div className="form-group mb-3 col-lg-4">
              <label>
                <strong>Currency</strong>
              </label>
              <select
                name="currency"
                className="form-control"
                value={formData.currency}
                onChange={handleChangeForm}
              >
                <option value="">Select</option>
                <option value="GBP">GBP</option>
                <option value="USD">USD</option>
                <option value="EURO">EURO</option>
                <option value="SAR">SAR</option>
                <option value="QD">QD</option>
                <option value="AED">AED</option>
                <option value="Other">Other</option>
              </select>
            </div>


            {/* <div className="form-group mb-3 col-lg-4">
  <label>
    <strong>Supplier Name</strong>
  </label>
  <Select
    name="supplier_name"
    options={[
      ...suppiler.map((s) => ({
        label: s.name,
        value: s.name,
      })),
      { label: "➕ Add New Supplier", value: "add_new" },
    ]}
    value={
      formData.supplier_name
        ? { label: formData.supplier_name, value: formData.supplier_name }
        : null
    }
    onChange={(selectedOption) => {
      if (!selectedOption) return;
      const value = selectedOption.value;

      // Redirect logic
      if (value === "add_new") {
        navigate("/supplierpo");
        return;
      }

      // Reuse your existing handleChangeForm logic
      handleChangeForm({
        target: { name: "supplier_name", value },
      });
    }}
    placeholder="Select Supplier"
    isSearchable
    classNamePrefix="react-select"
  />
</div> */}

             {[
             
             
               { label: "Supplier Name", name: "supplier_name" },
              { label: "Pearlcon Contact", name: "pearlcon_contact" },
              {
                label: "Supplier Delivery Date",
                name: "supplier_delivery_date",
                type: "date",
              },
              { label: "Current Status", name: "current_status" },
              { label: "RFQ Number", name: "rfq_number" },
            ].map(({ label, name, type = "text", readOnly = false }) => (
              <div className="form-group mb-3 col-lg-4" key={name}>
                <label>
                  <strong>{label}</strong>
                </label>
                <input
                  type={type}
                  name={name}
                  className="form-control"
                  value={formData[name]}
                  onChange={handleChangeForm}
                  readOnly={readOnly}
                />
              </div>
            ))}

            {/* Dropdown Fields */}
           

           

            <div className="form-group mb-3 col-lg-4">
              <label>
                <strong>Latest Update</strong>
              </label>
              <select
                name="latest_update"
                className="form-control"
                value={formData.latest_update}
                onChange={handleChangeForm}
              >
                <option value="">Select</option>
                <option value="Po Received From Client">
                  Po Received From Client
                </option>
                <option value="Po issued to supplier">
                  Po issued to supplier
                </option>
                <option value="Po Under Progress">Po Under Progress</option>
                <option value="Po Shipped">Po Shipped</option>
                 <option value="Commercial Invoice Issue">Commercial Invoice Issue</option>
                <option value="Payment Invoice Issue">Payment Invoice Issue</option>
                <option value="Payment Received">Payment Received</option>
                <option value="Po Closed">Po Closed</option>
              </select>
            </div>

            <div className="form-group mb-3 col-lg-4">
              <label>
                <strong>Supplier Payment</strong>
              </label>
              <select
                name="supplier_payment"
                className="form-control"
                value={formData.supplier_payment}
                onChange={handleChangeForm}
              >
                <option value="">Select</option>
                <option value="Advance With Order">Advance With Order</option>
                <option value="Advance Before Dispatch">
                  Advance Before Dispatch
                </option>
                <option value="OnCredit">OnCredit</option>
                <option value="Stage Payment">Stage Payment</option>
              </select>
            </div>
            {formData.supplier_payment === "Stage Payment" && (
              <div className="form-group mb-3 col-lg-4">
                <label>
                  <strong>Curent Remark</strong>
                </label>
                <input
                  type="text"
                  name="status_feedback"
                  className="form-control"
                  value={formData.status_feedback || ""}
                  onChange={handleChangeForm}
                />
              </div>
            )}

            <div className="form-group mb-3 col-lg-4">
              <label>
                <strong>Client Payment</strong>
              </label>
              <select
                name="client_payment"
                className="form-control"
                value={formData.client_payment}
                onChange={handleChangeForm}
              >
                <option value="">Select</option>
                <option value="Payment Pending">Payment Pending</option>
                <option value="Payment Received">Payment Received</option>
                <option value="Payment Delayed">Payment Delayed</option>
              </select>
            </div>
          </div>

          <div className="text-center">
            <button className="btn btncolor w-50 mt-3" onClick={handleSubmit}>
              Submit PO
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClonePO;

  
